import React, { CSSProperties, useState, useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../Core/hooks';
import { getRoadmap } from '../Store/Roadmap';
import { loadComponent, toggleChat, toggleWork, toggleRoadmaps, getSettings,
    toggleChatChannels, toggleChatMessages
 } from '../Store/Settings';
import { RiArrowDownSFill, RiArrowUpSFill } from "react-icons/ri";
import { RxDashboard } from "react-icons/rx";
import { BsBell } from "react-icons/bs";
import { LuKanban } from "react-icons/lu";
import { BiSolidLeftArrow, BiSearch } from "react-icons/bi";
import { IoChatbubbleOutline, IoMapOutline, IoSettingsOutline, IoPeopleOutline } from "react-icons/io5";
import { VscTriangleDown, VscTriangleUp } from "react-icons/vsc";
import { Roadmap } from '../Models/Roadmap';
import { channelType, loadedComponentType, loadedSubComponentType } from '../Helpers/types';
import { handleLoadComponent } from '../Helpers/handleLoadComponent';
import { FaRegFolder } from 'react-icons/fa';
import { AiOutlinePlus, AiOutlineClose } from "react-icons/ai";
import { createFolder, getFolder } from '../Store/Folder';
import { FaRegEdit } from "react-icons/fa";
import AddChatChannelContextMenu from '../Modals/AddChatChannelContextMenu';
import { AddChatChannelContextMenuParams } from '../Models/Requests/AddChatChannelContextMenuParams';
import EditChatChannelContextMenu from '../Modals/EditChatChannelContextMenu';
import { EditChatChannelContextMenuParams } from '../Models/Requests/EditChatChannelContextMenuParams';
import { getChat, loadChannel, setChatStatus, setChannels, saveChannels } from '../Store/Chat';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { FaCircle, FaRegCircle } from "react-icons/fa"; 
import Avatar from './Avatar';
import { Member } from '../Models/Requests/Member';
import { getUser } from '../Store/Auth';

function ChatSubNav() {

    const dispatch = useAppDispatch();
    const settingsState = useAppSelector(getSettings);
    //const roadmapState = useAppSelector(getRoadmap);
    const userState = useAppSelector(getUser);
    const chatState = useAppSelector(getChat);
    const roadmapState = useAppSelector(getRoadmap);
    const [search, setShowSearch] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [addChatChannelContextMenuParams, setAddChatChannelContextMenuParams] = useState<AddChatChannelContextMenuParams>();
    const [editChatChannelContextMenuParams, setEditChatChannelContextMenuParams] = useState<EditChatChannelContextMenuParams>();

    useEffect(() => {
        if (chatState.status === "channelLoaded") {
            dispatch(setChatStatus("idle"));
            handleLoadComponent(dispatch, "chat");
        }
    }, [chatState.status]);

    const handleShowAddChat = (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        setAddChatChannelContextMenuParams({ event: e, _id: "2" });   
    }
    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) =>  {
        e.preventDefault();
        setSearchText(e.currentTarget.value);
    }
    const handleShowAddChannelContext = (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        setAddChatChannelContextMenuParams({ event: e, _id: "1" });   
    }

    const onChannelDragEnd = (result: any) => {
        
        let id = result.draggableId;
        let newIndex = parseInt(result.destination.index);
        let oldIndex = parseInt(result.source.index);

        //let channels = [...chatState.channels];
        let channels = [...chatState.channels].sort((a, b) => a.sort - b.sort);
        let sourceChannel = chatState.channels.find(c => c._id === id);
        //console.log(channels);
        //console.log("New Index: " + newIndex);
        //console.log("Old Index: " + oldIndex);

        if (sourceChannel) {
            channels.splice(oldIndex, 1);
            channels.splice(newIndex, 0, sourceChannel);

            let sortedChannels = channels.map((c, i) => {
                return {...c, sort: i };
            });

            dispatch(setChannels(sortedChannels)); // update frontend
            dispatch(saveChannels(sortedChannels)); // update backend
            //console.log(channels);
        }
    }

    const handleChannelContextMenu = (e: React.MouseEvent<HTMLDivElement>, id: string, type: channelType) => {
        e.preventDefault();
        e.stopPropagation();
        setEditChatChannelContextMenuParams({ event: e, _id: id, type: type })
    }

    const getStyle = (style: any, channelId: string) => {
        let loadedChannel = chatState.channels.find(c => c.loaded);  
        // && settingsState.settings.loadedComponentType === "work"  
        if (loadedChannel && channelId === loadedChannel._id) {
            return {
                ...style,
                backgroundColor: "#bb4b01",
                borderRadius: "5px",
                color: "#fff",
                marginTop: "5px",
                marginBottom: "5px",
                //cursor: "auto"
            };
        } else {
            return { ...style };
        }
    }

    let sortedChannels = [...chatState.channels].sort((a, b) => a.sort - b.sort);
    //console.log(sortedChannels);
    let formattedChannels = sortedChannels.map((channel, index) => {
        if (channel.type === "channel") {
            //let messages = chatState.messages.filter(m => m.channelId === channel._id);
            let unreadMessages = chatState.messages.some(
                (msg) =>
                  !channel.loaded &&
                  msg.userId !== userState._id &&
                  (
                    (
                        msg.channelId === channel._id &&
                        new Date(msg.modified) > new Date(channel.lastUnloaded)
                    ) ||
                    (msg.channelId === channel._id && !channel.lastLoaded)
                  )
            )

            let channelStyle: CSSProperties = { 
                padding: "2px 0px 3px 10px",
                textOverflow: "ellipsis",
                width: "calc(80%)",
                overflow: "hidden", 
                fontSize: "10pt",
                whiteSpace: "nowrap",
                color: (unreadMessages) ? "#fff" : "#bec1c3",
                fontWeight: (unreadMessages) ? "bold" : "normal",
            }

            return (
                <Draggable key={channel._id} draggableId={channel._id} index={index}>
                    {(provided, snapshot) => (
                        <div className="chatNavChannel"
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={getStyle({...provided.draggableProps.style}, channel._id)}>
                            <div style={channelStyle}
                                onContextMenu={(e) => handleChannelContextMenu(e, channel._id, "channel")}
                                onClick={() => dispatch(loadChannel(channel._id))}>
                                {channel.name}
                            </div>
                        </div>
                    )}
                </Draggable>
            );
        }
    });

    let formattedMessages = sortedChannels.map((channel, index) => {
        if (channel.type === "direct message") {

            let unreadMessages = chatState.messages.some(
                (msg) =>
                    !channel.loaded &&
                    msg.userId !== userState._id &&
                    (
                        (
                            msg.channelId === channel._id &&
                            new Date(msg.modified) > new Date(channel.lastUnloaded)
                        ) ||
                        (msg.channelId === channel._id && !channel.lastLoaded)
                    )
            )

            let channelStyle: CSSProperties = { 
                display: "inline-block",
                position: "relative",
                marginLeft: "-3px", 
                fontSize: "10pt",
                textOverflow: "ellipsis",
                maxWidth: "100%", 
                overflow: "hidden",
                whiteSpace: "nowrap",
                color: (unreadMessages) ? "#fff" : "#bec1c3",
                fontWeight: (unreadMessages) ? "bold" : "normal",
            }
    
            //console.log(channel.name);

            /* We could have Adam, Kevin or Kevin, Adam. Get which name is not the current user */
            let nameToCheck = "";
            //let namePosition = 0;
            let names = channel.name.split(",");
            names.forEach((name, index) => {
                if (name !== "Me" && name !== " Me") {
                    nameToCheck = name.trim();
                    //namePosition = index;
                    //console.log(nameToCheck);
                }
            })
            
           // let userOnline = chatState.membersOnline.find(m => m.fullName === channel.name);
            let userOnline = chatState.membersOnline.find(m => m.fullName === nameToCheck);
            let member: Member | undefined = undefined;

            //let name = channel.name.split(" ");
            let name = nameToCheck.split(" ");
            //console.log(name);
            if (name.length === 2) {
                member = chatState.allChatMembers.find(m => m.firstName === name[0] && m.lastName === name[1]);
            }

            return (
                <Draggable key={channel._id} draggableId={channel._id} index={index}>
                    {(provided, snapshot) => (
                        <div className="chatNavChannel"
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={getStyle({...provided.draggableProps.style}, channel._id)}>
                            <div style={{ padding: "2px 0px 0px 10px", color: "#bec1c3" }}
                                onContextMenu={(e) => handleChannelContextMenu(e, channel._id, "direct message")}
                                onClick={() => dispatch(loadChannel(channel._id))}
                                >
                                    {(channel.name.split(",").length - 1) <= 1 &&
                                        <>
                                        <div style={{ display: "inline-block", position: "relative", top: "-5px"}}>
                                            <Avatar member={member} size="xxsmall" inline={true} />
                                        </div>
                                        {userOnline ?
                                            <div style={{ display: "inline-block", position: "relative", 
                                                top: "1px", left: "-7px" }}>
                                                <FaCircle size={10} color="#01d001" />
                                            </div>
                                        :
                                            <div style={{ display: "inline-block", position: "relative", 
                                                top: "1px", left: "-7px" }}>
                                                <FaCircle size={10} color="#FF0000" />
                                            </div>
                                        }
                                        </>
                                    }
                                <div style={channelStyle}>
                                    {channel.name}
                                </div>
                            </div>
                        </div>
                    )}
                </Draggable>
            );
        }
    });

    let expandedChannelsClass: CSSProperties = {
        width: "94%",
        margin: "0px auto",
        color: "#909495",
        paddingTop: "0px",
        overflowY: "scroll"
    }

    return (
        <div className="leftSubNavWrapper">
            <div style={{ width: "94%", margin: "0px auto", color: "#909495", paddingTop: "15px" }}>
                <div style={{ fontWeight: "500", color: "#F8F9FA", width: "40%",fontSize: "12pt", display: "inline-block" }}>
                    Chat
                </div>
                <div style={{ width: "60%", display: "inline-block", textAlign: "right" }}>
                    {!search ?
                        <div style={{ display: "inline-block", position: "relative", top: "1px", paddingRight: "10px", cursor: "pointer" }}
                            onClick={(e) => setShowSearch(true)}>
                            <BiSearch size={16} color="#909495" />
                        </div>
                    :
                        <div style={{ display: "inline-block", position: "relative", top: "1px", paddingRight: "10px", cursor: "pointer" }}
                            onClick={(e) => { setSearchText(""); setShowSearch(false) }}>
                            <AiOutlineClose size={16} color="#909495" />
                        </div>
                    }
                    {/*
                    <div style={{ display: "inline-block", paddingRight: "10px", cursor: "pointer" }}
                        onClick={(e) => createChatFolder(e)}>
                        <FaRegFolder size={14} color="#909495" />
                    </div>
                    */}
                    <div style={{ display: "inline-block", paddingRight: "0px", cursor: "pointer" }}
                        onClick={(e) => handleShowAddChat(e)}>
                        <FaRegEdit size={16} color="#909495" />
                    </div>
                </div>
            </div>
            <hr style={{ width: "94%", color: "#909495", margin: "15px auto 0px auto" }} />
            {search &&
                <div style={{ width: "94%", margin: "0px auto", color: "#909495", paddingTop: "20px" }}>
                    <input type="text" placeholder="Search channels..." className="navSearch"
                        value={searchText}
                        onChange={(e) => handleSearchChange(e)} />
                </div>
            }
            <div className="chatNavItems">
                <div style={{ height: "50%" }}>
                    <div className="chatNavItem">
                        <div style={{ display: "inline-block", paddingLeft: "10px", color: "#bec1c3",
                            textOverflow: "ellipsis", width: "calc(80%)", overflow: "hidden", whiteSpace: "nowrap" }}>
                            Channels
                        </div>
                                        
                        <div style={{ float: "right", paddingLeft: "5px" }}
                            onClick={() => dispatch(toggleChatChannels(!settingsState.settings.chatChannelsExpanded))}>
                            {settingsState.settings.chatChannelsExpanded ? 
                                <VscTriangleUp size={18} color="#bec1c3" />
                            :
                                <VscTriangleDown size={18} color="#bec1c3" />
                            }
                        </div>
                    </div>
                    <div className="chatNavSubItem">
                    {settingsState.settings.chatChannelsExpanded &&
                       <>
                            <div style={{ display: "inline-block", paddingLeft: "10px", paddingBottom: "5px", color: "#909495" }}
                                onClick={(e) => handleShowAddChannelContext(e) }>
                                <AiOutlinePlus color="#909495" /> Add Channels
                            </div>               
                            <div className="roadmapsExpanded" style={expandedChannelsClass}>             
                                <DragDropContext onDragEnd={(e) => onChannelDragEnd(e)}>                
                                    <Droppable droppableId={"1"}>
                                        {(provided, snapshot) => (
                                            <div {...provided.droppableProps} ref={provided.innerRef}>
                                                {formattedChannels}
                                                {provided.placeholder}
                                            </div>
                                        )}
                                    </Droppable>
                                </DragDropContext>                          
                            </div>
                        </>
                    }
                    <div className="chatNavItem">
                        <div style={{ display: "inline-block", paddingLeft: "10px", color: "#bec1c3",
                            textOverflow: "ellipsis", width: "calc(80%)", overflow: "hidden", whiteSpace: "nowrap" }}>
                            Direct Messages
                        </div>
                                        
                        <div style={{ float: "right", paddingLeft: "5px" }}
                            onClick={() => dispatch(toggleChatMessages(!settingsState.settings.chatMessagesExpanded))}>
                            {settingsState.settings.chatMessagesExpanded ? 
                                <VscTriangleUp size={18} color="#bec1c3" />
                            :
                                <VscTriangleDown size={18} color="#bec1c3" />
                            }
                        </div>
                    </div>
                    {settingsState.settings.chatMessagesExpanded &&
                        <>            
                            <div className="roadmapsExpanded" style={expandedChannelsClass}>             
                                <DragDropContext onDragEnd={(e) => onChannelDragEnd(e)}>                
                                    <Droppable droppableId={"1"}>
                                        {(provided, snapshot) => (
                                            <div {...provided.droppableProps} ref={provided.innerRef}>
                                                {formattedMessages}
                                                {provided.placeholder}
                                            </div>
                                        )}
                                    </Droppable>
                                </DragDropContext>                          
                            </div>
                        </>
                    }
                    </div>
                </div>
            </div>
            <AddChatChannelContextMenu params={addChatChannelContextMenuParams} />
            <EditChatChannelContextMenu params={editChatChannelContextMenuParams} />
        </div>
    );
}

export default ChatSubNav;